import { SHIPMENT_SOLUTION_TYPES } from "~/cores/shipment.core";
import { createReturnReasonConfigBottom, createReturnReasonConfigShoes, createReturnReasonConfigTop } from "../mockCore";

export function getExchange({ productId }) {
    if (productId === "1") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/Eytys Jeans - Light Stone.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Light Stone",
                        },
                        {
                            type: "Size",
                            value: "24",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/Eytys Jeans - Light Stone.jpeg",
                    inventoryMerchant: 0,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Light Stone",
                        },
                        {
                            type: "Size",
                            value: "28",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/Eytys Jeans - Light Stone.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 0,
                    properties: [
                        {
                            type: "Color",
                            value: "Light Stone",
                        },
                        {
                            type: "Size",
                            value: "30",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/Eytys Jeans - Light Stone.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Light Stone",
                        },
                        {
                            type: "Size",
                            value: "32",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/Eytys Jeans - Cali Black.jpeg",
                    inventoryMerchant: 0,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Cali Black",
                        },
                        {
                            type: "Size",
                            value: "26",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/Eytys Jeans - Cali Black.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Cali Black",
                        },
                        {
                            type: "Size",
                            value: "28",
                        },
                    ],
                },
                {
                    id: "7",
                    imageUrl: "/mocks/Eytys Jeans - Cali Black.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Cali Black",
                        },
                        {
                            type: "Size",
                            value: "30",
                        },
                    ],
                },
            ],
        };
    }
    if (productId === "2") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/Eytys Sneakers - White.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Size",
                            value: "37",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/Eytys Sneakers - White.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Size",
                            value: "39",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/Eytys Sneakers - White.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Size",
                            value: "40",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/Eytys Sneakers - Black.jpeg",
                    inventoryMerchant: 2,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "37",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/Eytys Sneakers - Black.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "38",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/Eytys Sneakers - Black.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "39",
                        },
                    ],
                },
            ],
        };
    }

    if (productId === "3") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/Eytys Tshirt - Pale Blue.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Pale Blue",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/Eytys Tshirt - Pale Blue.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Pale Blue",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/Eytys Tshirt - Pale Blue.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Pale Blue",
                        },
                        {
                            type: "Size",
                            value: "L",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/Eytys Tshirt - White.jpeg",
                    inventoryMerchant: 2,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/Eytys Tshirt - White.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/Eytys Tshirt - White.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                        {
                            type: "Size",
                            value: "L",
                        },
                    ],
                },
            ],
        };
    }

    return {
        exchangeAlternatives: [
            {
                id: "1",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 2,
                properties: [
                    {
                        type: "Color",
                        value: "Red",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                id: "2",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 2,
                properties: [
                    {
                        type: "Color",
                        value: "Red",
                    },
                    {
                        type: "Size",
                        value: "L",
                    },
                ],
            },
            {
                id: "3",
                inventoryMerchant: 0,
                inventoryTurnr: 1,
                inventoryTotal: 1,
                properties: [
                    {
                        type: "Color",
                        value: "White",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                id: "4",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 0,
                properties: [
                    {
                        type: "Color",
                        value: "White",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                id: "4",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Green",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
        ],
    };
}

export function getProducts() {
    return {
        sessionId: "170bfc7b-8910-43a7-8903-52c9894ed015",
        shipmentSolutions: [
            {
                carrier: "DOORIS",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 0,
            },
            {
                carrier: "BUDBEE",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 39,
            },
            {
                carrier: "POSTNORD",
                type: SHIPMENT_SOLUTION_TYPES.PRINT_LABEL.key,
                cost: 39,
            },
        ],
        pickupDateSelectionAllowed: true,
        paidShipping: 40,
        turnrShippingCost: 59,
        currencyCode: "SEK",
        refundOptions: [
            {
                type: "BASIC",
            },
            {
                type: "GIFT_CARD",
                bonusPercentage: 0.2,
            },
        ],
        products: [
            {
                productVariantId: 10,
                sessionItemId: 1,
                productName: "Benz Jeans",
                imageSrc: "/mocks/Eytys Jeans - Light Stone.jpeg",
                imageAlt: "/mocks/Eytys Jeans - Light Stone.jpeg",
                quantity: 1,
                purchasePrice: 2200,
                properties: [
                    {
                        type: "Size",
                        value: "26",
                    },
                    {
                        type: "Color",
                        value: "Light Stone",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigBottom(),
            },
            {
                productVariantId: 20,
                sessionItemId: 2,
                productName: "Doja Sneakers",
                imageSrc: "/mocks/Eytys Sneakers - White.jpeg",
                imageAlt: "/mocks/Eytys Sneakers - White.jpeg",
                quantity: 1,
                purchasePrice: 1900,
                properties: [
                    {
                        type: "Color",
                        value: "White",
                    },
                    {
                        type: "Size",
                        value: "38",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigShoes(),
            },
            {
                productVariantId: 30,
                sessionItemId: 3,
                productName: "Eden Logo T-shirt",
                imageSrc: "/mocks/Eytys Tshirt - Pale Blue.jpeg",
                imageAlt: "/mocks/Eytys Tshirt - Pale Blue.jpeg",
                quantity: 1,
                purchasePrice: 1000,
                properties: [
                    {
                        type: "Size",
                        value: "S",
                    },
                    {
                        type: "Color",
                        value: "Pale Blue",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigTop(),
            },
        ],
    };
}
